import { Box, styled } from '@planne-software/uni/mui/material';

export const ContentBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile: boolean }>(({ isMobile, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  padding: isMobile ? '1rem' : '1.5rem',
  fontFamily: theme.typography.fontFamily,
}));

export const FooterColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  width: '100%',
});

export const TotalRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  width: '100%',
  color: theme.tokens.colors['text-color-neutral-strongest'],
}));

export const TotalLabel = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-md-medium'],
  fontFamily: theme.typography.fontFamily,
}));

export const TotalValue = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['display-sm-bold'],
  fontFamily: theme.typography.fontFamily,
}));

export const EmptyMessage = styled(Box)(({ theme }) => ({
  ...theme.tokens.typography['text-sm-regular'],
  fontFamily: theme.typography.fontFamily,
  color: theme.tokens.colors['text-color-neutral-stronger'],
  textAlign: 'center',
  padding: '2rem 1rem',
}));
